import React, { useState, useEffect } from "react";
import { AddToastFunction } from "../../../utils/types/toast";
import { PageHeader } from "@salesforce/design-system-react";
import AccountMigrationCreation from "../../account_management/account_migration/account_creation/AccountMigrationCreation";
import AccountMigrationStatus from "../../account_management/account_migration/status/AccountMigrationStatus";
import { ToastState, ToastType } from "../../../utils/types/toast";

type PCSKAccountMigrationPageProps = {
    addToast: AddToastFunction;
    navigationBar: React.ReactNode | null;
};

const PCSKAccountMigrationPage: React.FC<PCSKAccountMigrationPageProps> = ({ navigationBar, addToast }) => {
    const [toast, setToast] = useState<ToastState>({ 
        isVisible: false, 
        message: { heading: "" }, 
        variant: "success" 
    });

    // Bridge the local toast state to the main app's toast system
    useEffect(() => {
        if (toast.isVisible && toast.message?.heading) {
            addToast(
                toast.message.heading,
                toast.message.details || "",
                toast.variant as ToastType
            );
            
            // Reset the local toast state
            setToast({ 
                isVisible: false, 
                message: { heading: "" }, 
                variant: "success" 
            });
        }
    }, [toast, addToast]);

    return (
        <>
            {navigationBar && navigationBar}
            <div className="slds-m-around_medium">
                <PageHeader
                    title="Account Migration"
                    info="Request and track account migration for AWS accounts"
                />
                <div style={{ minHeight: "80vh" }}>
                    <div className="slds-grid slds-gutters">
                        <div className="slds-col slds-size--5-of-8">
                            <AccountMigrationCreation 
                                isActive={true} 
                                toast={toast} 
                                setToast={setToast} 
                            />
                        </div>
                        <div className="slds-col slds-size--3-of-8">
                            <AccountMigrationStatus 
                                isActive={true} 
                                setToast={setToast} 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PCSKAccountMigrationPage;
